import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFetch } from '@legacy/utils/fetcher';
import {
  DELETE_SAVED_VIEW_MSW_STATUS_KEY,
  GET_SAVED_VIEW_KEY,
} from '../constants';

const DELETE_SAVED_VIEW_URL_PATH = '/api/v2/filter-view';

const deleteSavedView = (filterViewId: string) =>
  deleteFetch({
    path: `${DELETE_SAVED_VIEW_URL_PATH}/${filterViewId}`,
    key: DELETE_SAVED_VIEW_MSW_STATUS_KEY,
  });

export const useDeleteSavedView = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSavedView,

    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_SAVED_VIEW_KEY],
        }),
      ]),
  });
};
